import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import AgeGate from "@/components/AgeGate";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import ProductDetail from "@/pages/ProductDetail";
import CreateListing from "@/pages/CreateListing";
import Messages from "@/pages/Messages";
import Dashboard from "@/pages/Dashboard";
import Favorites from "@/pages/Favorites";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Revenue from "@/pages/Revenue";
import Moderation from "@/pages/Moderation";
import AdminProducts from "@/pages/AdminProducts";
import AdminUsers from "@/pages/AdminUsers";
import Analytics from "@/pages/Analytics";
import PageTracker from "@/components/PageTracker";
import MyBids from "@/pages/MyBids";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import CreateService from "@/pages/CreateService";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Laden...</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function Footer() {
  return (
    <footer className="border-t border-zinc-800/60 mt-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-zinc-500">
        <div className="flex items-center gap-2">
          <span className="font-serif text-xl font-semibold text-zinc-300">FETSHOP</span>
          <span className="text-xs">— Discrete marktplaats · 18+</span>
        </div>
        <div className="text-xs text-zinc-600">Uitsluitend voor volwassenen. Handel veilig en respectvol.</div>
      </div>
    </footer>
  );
}

function Shell({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AgeGate>
        <AuthProvider>
        <BrowserRouter>
          <PageTracker />
          <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route path="/wachtwoord-herstellen" element={<ResetPassword />} />
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/product/:id" element={<Shell><ProductDetail /></Shell>} />
            <Route path="/diensten" element={<Shell><Services /></Shell>} />
            <Route path="/dienst/:id" element={<Shell><ServiceDetail /></Shell>} />
            <Route path="/dienst-plaatsen" element={<Protected><Shell><CreateService /></Shell></Protected>} />
            <Route path="/dienst-plaatsen/:id" element={<Protected><Shell><CreateService /></Shell></Protected>} />
            <Route path="/plaats" element={<Protected><Shell><CreateListing /></Shell></Protected>} />
            <Route path="/plaats/:id" element={<Protected><Shell><CreateListing /></Shell></Protected>} />
            <Route path="/berichten" element={<Protected><Shell><Messages /></Shell></Protected>} />
            <Route path="/dashboard" element={<Protected><Shell><Dashboard /></Shell></Protected>} />
            <Route path="/favorieten" element={<Protected><Shell><Favorites /></Shell></Protected>} />
            <Route path="/mijn-biedingen" element={<Protected><Shell><MyBids /></Shell></Protected>} />
            <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
            <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
            <Route path="/omzet" element={<Protected><Shell><Revenue /></Shell></Protected>} />
            <Route path="/moderatie" element={<Protected><Shell><Moderation /></Shell></Protected>} />
            <Route path="/advertenties" element={<Protected><Shell><AdminProducts /></Shell></Protected>} />
            <Route path="/gebruikers" element={<Protected><Shell><AdminUsers /></Shell></Protected>} />
            <Route path="/bezoekers" element={<Protected><Shell><Analytics /></Shell></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </AuthProvider>
    </AgeGate>
    </LanguageProvider>
  );
}

export default App;
